<p>attendances works!</p>